import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import { Ids } from '../../../constants/Ids'
import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_10.jpg'
import { IPurchaseResponse } from '../../../models/Purchase'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Sections } from '../../organisms/Sections'
import Breadcrumbs from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'

const PurchaseScreen = () => {
  const i18n = useRecoilValue(translate).purchase
  const breadcrumbs = [
    {
      link: routes.purchase,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IPurchaseResponse>(URI.getDataUri('/purchase', lang))

  return (
    <React.Suspense fallback={<Loading />}>
      <ImageSection id={Ids.property} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data?.sections.length && <Sections sections={data.data.sections} />}
      </PageWrapper>
    </React.Suspense>
  )
}

export default PurchaseScreen
